<template>
  <signup-component @signup="handleSignUp"></signup-component>
</template>

<script>
import SignupComponent from '@/components/user/SignupComponent'
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'

export default {
    components: {SignupComponent},
    name:"Signup",
    computed: {
      ...mapGetters([
        'base_url'
      ]),
    },
    mounted(){
      this.setBreadcrumb()
    },
    methods: {        
      ...mapMutations([
          'SET_BREADCRUMB'
      ]),
      setBreadcrumb: function(){
        this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
      },
      handleSignUp: function(user){
        axios.post(`${this.base_url}accounts/signup/`, user)
          .then(response => {
            console.log('response: ', response)
            this.$toast.open({
                duration: 5000,
                type: 'is-success',
                message: `Account created`,
                icon: 'info_outline',
                position: "is-top",
            });
            this.$router.push({ name: "Login" });
          })
        .catch(error => {
          console.log("Validation error:", error.response.data)
          if(error.response.data.email){
            this.$toast.open({
              type: 'is-danger',
              icon: 'error_outline',
              duration: 5000,
              position: "is-top",
              message: "Email " + error.response.data.email[0]
            });
          }  
          else{
            this.$toast.open({
              type: 'is-danger',
              icon: 'error_outline',
              duration: 5000,
              position: "is-top",
              message: `Something went wrong`
            });
          }    
        });
      }
    }
  }
</script>